import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Pagination from "../../common/TablePagination";
import "../../Fundraiser/FundsDeposited/fundsDeposited.scss";
import { useDispatch, useSelector } from "react-redux";
import { separateDateTimeAndConvertToLocale } from "../../../utils/utilFunctions";
// import debounce from "lodash.debounce";

const FundsDepositedTable = ({ searchQuery }) => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.adminReducer?.loading);
  const debit = useSelector((state) => state?.adminReducer?.transactions?.debit);

  const filtered = React.useMemo(() => {
    const q = (searchQuery || '').toLowerCase().trim();
    if (!q) return debit || [];
    return (debit || []).filter((row) => {
      const values = [
        row?._id,
        separateDateTimeAndConvertToLocale(row?.createdAt)?.localDate,
        row?.fundraiser?.user?.name,
        String(row?.fundraiserFunds)
      ];
      return values.some((v) => String(v || '').toLowerCase().includes(q));
    });
  }, [debit, searchQuery]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  // const [count, setCount] = useState(0);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    // getFundsData(searchQuery);
  };

  const columns = [
    {
      name: "ID",
    },
    {
      name: "Date",
    },
    {
      name: "Fundraiser",
    },
    {
      name: "Funds",
    },
  ];

  return (
    <div className="col-span-12">
      <TableContainer className="w-[100%]">
        <Table
          sx={{ borderCollapse: "separate", borderSpacing: "0px 8px" }}
          aria-label="simple table"
        >
          <TableHead className="bg-[#00ADEF]">
            <TableRow
              className="h-[50px]"
              sx={{ boxShadow: "0px 4px 4px 0px #00000040" }}
            >
              {columns.map((column) => {
                return (
                  <TableCell className="!text-[#FFFFFF] !font-[500] !text-[14px]">
                    {column.name}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>

          <TableBody>
            {filtered && filtered?.length > 0 ? (
              filtered?.map((funds, index) => (
                <TableRow
                  key={index}
                  className="h-[50px]"
                  sx={{
                    boxShadow: "0px 4px 4px 0px #00000040",
                    backgroundColor:
                      (index + 1) % 2 !== 0 ? "#F5F5F5" : "#FFFFFF",
                  }}
                >
                  <TableCell>{funds?._id}</TableCell>
                  <TableCell>
                    {
                      separateDateTimeAndConvertToLocale(funds?.createdAt)
                        ?.localDate
                    }
                  </TableCell>
                  <TableCell>{funds?.fundraiser?.user?.name}</TableCell>
                  <TableCell>${funds?.fundraiserFunds}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={columns.length}
                  align="center"
                  className="text-[16px] font-poppins font-[400] text-gray-500"
                >
                  No data found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Pagination totalPages={totalPages} handlePageChange={handlePageChange} />
    </div>
  );
};

export default FundsDepositedTable;